import styled from '@emotion/styled';
import { Box, CircularProgress, CssBaseline } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import StepWizard from 'react-step-wizard';

import { useMst } from '../models/rootModel';
import { LoaderDiv } from './styledComponent/Boxes.style';

import { Global } from '@emotion/react';
import { GlobalStyle } from '../global.style';
import { useFeatureFlags } from '../providers/featureFlag/featureFlag.context';
import { ComponentFactory } from './common/ComponentFactory';
import { getColor } from './common/UICommon';
import { useImagesPreload } from '../hooks/useImagesPreload.hook';

const customTransitions = {
  enterRight: '',
  enterLeft: '',
  exitRight: '',
  exitLeft: '',
  intro: '',
};

const MainRoot = styled(Box)`
  background-color: ${getColor('DARK_CREAM')};
`;

interface Props {
  isLoadingData: boolean;
}

export const OnboardingContainer: React.FC<Props> = observer((props) => {
  const { Step, Criteria, UserProgress, PlanLabels, UserPayment } = useMst();
  const featureFlags = useFeatureFlags();

  // steps are counted from 1, not from 0
  const handleStepChange = (stepChange: { previousStep: number; activeStep: number }) => {
    const stepIndex = stepChange.activeStep - 1;
    UserProgress.setCurrentStep(stepIndex);
    UserProgress.addStep(Step.steps[stepIndex].stepName);
  };

  useEffect(() => {
    if (Step.isCriteriasPreLoaded && Criteria.criterias.length === 0) {
      Criteria.getCriterias(Step.criteriaOrigin || Step.origin);
    }
  }, [Step.isCriteriasPreLoaded, Step.origin, Step.criteriaOrigin, Criteria]);

  useEffect(() => {
    if (Step.isLabelsPreLoaded && PlanLabels.allPlanLabels.size === 0) {
      PlanLabels.fetchAndSetAllPlanLabels();
    }
  }, [Step.isLabelsPreLoaded, PlanLabels]);

  useEffect(() => {
    if (Step.steps.length > 0) {
      UserProgress.addStep(Step.steps[0].stepName);
    }
  }, [Step.steps, Step.steps.length, UserProgress]);

  useEffect(() => {
    if (Step.enableProgram) {
      UserPayment.setEnableProgram(true);
      UserPayment.getStripePlans();
    }
  }, [Step.enableProgram, UserPayment]);

  useImagesPreload({ isLoadingData: props.isLoadingData });

  return (
    <MainRoot>
      <CssBaseline />
      <Global styles={GlobalStyle} />
      {Step.steps.length > 0 && !props.isLoadingData && featureFlags.isInitialized ? (
        <StepWizard transitions={customTransitions} onStepChange={handleStepChange}>
          {Step.steps.map((step, index) => ComponentFactory(step, index))}
        </StepWizard>
      ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )}
    </MainRoot>
  );
});
